(function () {
  'use strict';

  /* Hero: preview a letter on the pendant */
  document.querySelectorAll('[data-hero]').forEach(function (hero) {
    var big = hero.querySelector('.js-hero-letter');
    var section = hero.closest('.hero');
    var link = section ? section.querySelector('.js-hero-link') : null;
    if (!big) return;
    hero.querySelectorAll('.letter').forEach(function (a) {
      function show() {
        if (big.textContent === a.dataset.letter) return;
        big.textContent = a.dataset.letter;
        hero.querySelectorAll('.letter.is-active').forEach(function (x) { x.classList.remove('is-active'); });
        a.classList.add('is-active');
        if (link) link.href = a.href;
        big.classList.remove('swap');
        void big.offsetWidth;
        big.classList.add('swap');
      }
      a.addEventListener('mouseenter', show);
      a.addEventListener('focus', show);
    });
  });

  /* Product: variant selection + gallery */
  document.querySelectorAll('[data-product]').forEach(function (root) {
    var dataEl = root.querySelector('.js-variants');
    if (!dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    var idInput = root.querySelector('.js-variant-id');
    var btn = root.querySelector('.js-add');
    var priceEl = root.querySelector('.product-info .js-price');
    var compareEl = root.querySelector('.product-info .js-compare');
    var mainImg = root.querySelector('.js-main-image');
    var mainWrap = root.querySelector('.js-gallery-main');
    var thumbList = root.querySelector('.js-thumbs');
    var countEl = root.querySelector('.js-gal-count');
    var currency = root.dataset.currency || 'EUR';
    var fmt = new Intl.NumberFormat(document.documentElement.lang || 'de-DE', { style: 'currency', currency: currency });

    function money(cents) { return fmt.format(cents / 100); }

    function setImage(src) {
      if (!mainImg || !src) return;
      mainImg.removeAttribute('srcset');
      mainImg.classList.add('is-swapping');
      var pre = new Image();
      pre.onload = pre.onerror = function () { mainImg.src = src; mainImg.classList.remove('is-swapping'); };
      pre.src = src;
    }

    /* Gallery per variant: photos whose alt text names variant values only show when all of those values are selected */
    function words(str) {
      return (str || '').toLowerCase().split(/[^a-z0-9À-ɏ]+/).filter(Boolean);
    }
    var optionWords = [];
    variants.forEach(function (v) {
      (v.options || []).forEach(function (val, i) {
        if (!optionWords[i]) optionWords[i] = {};
        words(val).forEach(function (w) { if (w.length >= 3) optionWords[i][w] = true; });
      });
    });
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('.js-thumb'));

    function visibleThumbs() {
      return thumbs.filter(function (t) { var li = t.closest('li'); return !li || !li.hidden; });
    }

    function updateCount() {
      if (!countEl) return;
      var v = visibleThumbs();
      var i = v.findIndex(function (t) { return t.classList.contains('is-active'); });
      countEl.textContent = v.length > 1 ? ((i < 0 ? 0 : i) + 1) + ' / ' + v.length : '';
    }

    function centerThumb(t) {
      if (!thumbList || !t) return;
      var li = t.closest('li') || t;
      thumbList.scrollTo({ left: li.offsetLeft - thumbList.clientWidth / 2 + li.offsetWidth / 2, behavior: 'smooth' });
    }

    function activate(t) {
      setImage(t.dataset.src);
      thumbs.forEach(function (x) { x.classList.remove('is-active'); });
      t.classList.add('is-active');
      centerThumb(t);
      updateCount();
    }

    function go(dir) {
      var v = visibleThumbs();
      if (v.length < 2) return;
      var i = v.findIndex(function (t) { return t.classList.contains('is-active'); });
      i = i < 0 ? 0 : (i + dir + v.length) % v.length;
      activate(v[i]);
    }

    function filterThumbs(v) {
      if (!v || !thumbs.length) return;
      thumbs.forEach(function (t) {
        var altWords = words(t.dataset.alt);
        var show = true;
        optionWords.forEach(function (set, i) {
          if (!set) return;
          var mentioned = altWords.filter(function (w) { return set[w]; });
          if (!mentioned.length) return;
          var selWords = words(v.options[i]);
          var ok = mentioned.every(function (w) { return selWords.indexOf(w) > -1; });
          if (!ok) show = false;
        });
        var li = t.closest('li');
        if (li) li.hidden = !show;
      });
      updateCount();
    }

    function selected() {
      return Array.prototype.map.call(root.querySelectorAll('fieldset.opt'), function (fs) {
        var sel = fs.querySelector('select.js-opt');
        if (sel) return sel.value;
        var r = fs.querySelector('input.js-opt:checked');
        return r ? r.value : null;
      });
    }

    function findVariant() {
      var vals = selected();
      return variants.find(function (x) {
        return vals.every(function (val, i) { return x.options[i] === val; });
      });
    }

    function update() {
      var vals = selected();
      root.querySelectorAll('fieldset.opt').forEach(function (fs, i) {
        var label = fs.querySelector('.js-opt-label');
        if (label) label.textContent = vals[i] || '';
      });
      var v = findVariant();
      if (!v) {
        btn.disabled = true;
        btn.textContent = 'Nicht verfügbar';
        return;
      }
      idInput.value = v.id;
      btn.disabled = !v.available;
      btn.textContent = v.available ? btn.dataset.label : 'Ausverkauft';
      if (priceEl) priceEl.textContent = money(v.price);
      if (compareEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          compareEl.textContent = money(v.compare_at_price);
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }
      filterThumbs(v);
      if (v.featured_image && v.featured_image.src) {
        var base = v.featured_image.src.split('?')[0].split('/').pop().replace(/\.[a-z]+$/i, '');
        var match = visibleThumbs().find(function (t) { return t.dataset.src.indexOf(base) > -1; });
        if (match) {
          activate(match);
        } else {
          var src = v.featured_image.src;
          setImage(src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=1200');
        }
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState(null, '', url.toString());
    }

    root.addEventListener('change', function (e) {
      if (e.target.classList.contains('js-opt')) update();
    });

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { activate(t); });
    });

    var prev = root.querySelector('.js-gal-prev');
    var next = root.querySelector('.js-gal-next');
    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });

    if (mainWrap) {
      var x0 = null, y0 = null;
      mainWrap.addEventListener('touchstart', function (e) { var p = e.touches[0]; x0 = p.clientX; y0 = p.clientY; }, { passive: true });
      mainWrap.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var p = e.changedTouches[0], dx = p.clientX - x0, dy = p.clientY - y0;
        x0 = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) go(dx < 0 ? 1 : -1);
      }, { passive: true });
    }

    filterThumbs(findVariant());
    var act = thumbs.find(function (t) { return t.classList.contains('is-active'); });
    if (act) centerThumb(act);
    updateCount();
  });

  /* Product form: add the gift box together with the jewellery */
  document.querySelectorAll('.js-product-form').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      var gift = form.querySelector('.js-gift');
      if (!gift || !gift.checked || !window.fetch) return;
      e.preventDefault();
      var idEl = form.querySelector('.js-variant-id');
      var qtyEl = form.querySelector('.js-qty');
      var qty = parseInt(qtyEl && qtyEl.value, 10) || 1;
      var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var btn = form.querySelector('.js-add');
      if (btn) btn.disabled = true;
      fetch(base + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [
          { id: Number(idEl.value), quantity: qty },
          { id: Number(gift.value), quantity: 1 }
        ] })
      }).then(function (r) {
        if (!r.ok) throw new Error('add failed');
        window.location.href = base + 'cart';
      }).catch(function () {
        if (btn) btn.disabled = false;
        HTMLFormElement.prototype.submit.call(form);
      });
    });
  });

  /* Product cards on touch screens: dots follow the swipe */
  document.querySelectorAll('.js-card-swipe').forEach(function (m) {
    var card = m.closest('.card');
    var dots = card ? card.querySelectorAll('.card-dots span') : [];
    if (!dots.length) return;
    m.addEventListener('scroll', function () {
      var i = Math.round(m.scrollLeft / Math.max(m.clientWidth, 1));
      Array.prototype.forEach.call(dots, function (d, k) { d.classList.toggle('is-active', k === i); });
    }, { passive: true });
  });
})();

(function () {
  document.querySelectorAll('[data-readmore]').forEach(function (wrap) {
    var box = wrap.querySelector('.product-desc');
    var btn = wrap.querySelector('.read-more');
    if (!box || !btn) return;
    if (box.scrollHeight <= box.clientHeight + 8) { box.classList.remove('is-clamped'); return; }
    btn.hidden = false;
    btn.addEventListener('click', function () {
      var open = box.classList.toggle('is-clamped') === false;
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.textContent = open ? btn.dataset.less : btn.dataset.more;
    });
  });
})();
